import { create } from "zustand";
import type { VehicleSearchResult, VehicleDetailResult } from "@/lib/api";

export type SidePanelContent =
  | { type: "search"; data: VehicleSearchResult }
  | { type: "detail"; data: VehicleDetailResult };

type SidePanelState = {
  content: SidePanelContent | null;
  lastOpenedToolCallId: string | null;
  open: (content: SidePanelContent, toolCallId: string) => void;
  close: () => void;
};

export const useSidePanelStore = create<SidePanelState>((set) => ({
  content: null,
  lastOpenedToolCallId: null,
  open: (content, toolCallId) => {
    console.log("[SidePanel] open()", { type: content.type, toolCallId });
    set({ content, lastOpenedToolCallId: toolCallId });
  },
  close: () => {
    console.log("[SidePanel] close()", new Error("trace").stack);
    set({ content: null, lastOpenedToolCallId: null });
  },
}));
